import { MediaContentShowcaseItem } from "onnit-ui/lib/module/MediaContentShowcase";

const ingredientsFlowBlend: MediaContentShowcaseItem[] = [
    {
        image: `l-theanine.png?q=75&auto=compress,format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-theanine",
        summary:
            'An amino acid that stimulates the release of dopamine and serotonin in the brain—two hormones that induce relaxation via alpha wave activity.<span class="oui-sup">&dagger;</span>',
        detail:
            'Shown to promote attention and reaction time.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `l-tyrosine.png?q=75&auto=compress,format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-tyrosine",
        summary:
            'An amino acid that helps the body produce adrenaline and dopamine.<span class="oui-sup">&dagger;</span>',
        detail:
            'Shown to aid cognitive performance in stressful situations.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `phosphatidylserine.png?q=75&auto=compress,format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Phosphatidylserine",
        summary: "A type of fat found in cell membranes.",
        detail:
            'Plays a key role in the maintenance of cellular function, especially in the brain.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `oat-straw-extract.png?q=75&auto=compress,format`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Oat Straw Extract",
        summary: "A compound extracted from oats.",
        detail:
            'Thought to promote cognitive function.<span class="oui-sup">&dagger;</span> No wonder they call oatmeal &ldquo;brain food!&rdquo;',
    },
];

export default ingredientsFlowBlend;
